import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Spin} from "antd";
// import dayjs from "dayjs";
// import { all_routes } from "../../../../../../Router/all_routes";
import CommonFooter from "../../../../../../core/common/footer/commonFooter";
// import { Edit, Eye, Trash2 } from "feather-icons-react/build/IconComponents";
// import Search from "antd/es/input/Search";
// import { Eye } from "feather-icons-react/build/IconComponents";
import { useEffect } from "react";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import Table from "../../../../../../core/pagination/datatable";

const PaymentsTabs = ({ CustomerData }) => {
  // const route = all_routes;

  const customerId = CustomerData?.customerId;

  const columns = [
    {
      title: "Payments",
      dataIndex: "id",
      key: "id",
      render: (id) => `PY-${id}`,
    },

    {
      title: "Invoice",
      key: "invoice",
      render: (_, record) => {
        const invoiceNo = `${record.InvoicePrefix || ""}${
          record.InvoiceNumber || ""
        }`;

        return (
          <span title={invoiceNo}>
              <i className="fa-regular fa-file-lines me-2 text-primary"></i>
            {invoiceNo.length > 15
              ? `${invoiceNo.substring(0, 15)}...`
              : invoiceNo}
          </span>
        );
      },
    },

    {
  title: "Mode",
  dataIndex: "PaymentModeName",
  key: "PaymentModeName",
  render: (text) => {
    const mode = (text || "").toLowerCase();

    let badgeClass = "badge bg-soft-secondary";

    if (mode === "upi") {
      badgeClass = "badge bg-soft-info";
    } else if (mode === "cash") {
      badgeClass = "badge bg-soft-success";
    } else if (mode === "card") {
      badgeClass = "badge bg-soft-primary";
    } else if (mode === "cheque") {
      badgeClass = "badge bg-soft-warning text-dark";
    }

    return (
      <span className={badgeClass}>
        {text || "N/A"}
      </span>
    );
  },
  sorter: (a, b) =>
    (a.PaymentModeName || "").localeCompare(b.PaymentModeName || ""),
},

    {
      title: "Transaction ID",
      dataIndex: "transactionid",
      key: "transactionid",
      render: (text) => {
        const value = text || "-";

        return (
          <span title={value}>
            {value.length > 15 ? `${value.substring(0, 15)}...` : value}
          </span>
        );
      },
      sorter: (a, b) =>
        (a.transactionid || "").localeCompare(b.transactionid || ""),
    },

    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => {
        const value = text ?? "0.00";

        return <span className="text-success">  <i className="fa-solid fa-indian-rupee-sign me-2"></i>{value}</span>;
      },
      sorter: (a, b) => Number(a.amount || 0) - Number(b.amount || 0),
    },

    {
      title: "Date",
      dataIndex: "date",

      render: (date) => {
        const created = dayjs(date);

        return (
          <div>
            <i className="fa-regular fa-calendar me-2 text-info"></i>
            {created.isValid() ? created.format("DD-MM-YYYY") : "-"}
          </div>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      render: () => (
        <div className="action-table-data">
          <div className="edit-delete-action ">
            <Link
              // to={`/crm/viewpayments/${record.id}`}
              to="/crm/viewpayments"
              className="btn"
            >
              <i className="ti ti-eye text-info"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const [paymentsData, setPaymentsData] = useState([]);
  const [paymentsCount, SetpaymentCounts] = useState([]);

  console.log(paymentsCount, "pppppppppppp");

  const [loading, setLoading] = useState(false);
  console.log(paymentsData, paymentsCount, loading);

  const getPayments = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${BASE_CRM_URL}payments/GetCustPayments?ClientId=${customerId}`,
      );
      const data = await response.json();

      if (data.Status) {
        setPaymentsData(data.ResultData || []);
      } else {
        setPaymentsData([]);
      }
    } catch (error) {
      console.error("Error fetching payments list", error);
      setPaymentsData([]);
    } finally {
      setLoading(false);
    }
  };
  const getPaymentsCount = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}payments/GetCustPaymnetCount?ClientId=${customerId}`,
      );

      const data = await response.json();

      if (data.Status) {
        SetpaymentCounts(data.ResultData?.[0] || {});
      } else {
        SetpaymentCounts([]);
      }
    } catch (error) {
      console.error("Error fetching payments count list", error);
      SetpaymentCounts([]);
    }
  };

  useEffect(() => {
    getPayments();
    getPaymentsCount();
  }, []);

  return (
    <>
      <div className="row g-3">
        {/* Draft */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div className="card flex-fill shadow-sm">
            <div className="card-body d-flex justify-content-between align-items-center  py-2 px-3">
              <div className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-0 fw-bold">{paymentsCount?.TotalPayments}</h4>
                <p className="mb-0  fw-semibold">Total</p>
              </div>

              <div
                className="rounded-circle bg-warning bg-opacity-10 d-flex justify-content-center align-items-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-money-check-dollar text-primary fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Sent */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div className="card flex-fill  shadow-sm">
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-1 fw-bold">
                  {" "}
                  ₹{" "}
                  {Number(paymentsCount?.AmountReceived || 0).toLocaleString(
                    "en-IN",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  )}
                </h4>
                <p className="mb-0  fw-semibold">Amount</p>
              </div>

              <div
                className="rounded-circle bg-success bg-opacity-10 d-flex justify-content-center align-items-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-sack-dollar text-success fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Expired */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div className="card flex-fill  shadow-sm">
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-1 fw-bold">
                  {paymentsCount?.TodaysPayments}
                </h4>
                <p className="mb-0  fw-semibold">Today </p>
              </div>

              <div
                className="rounded-circle bg-info bg-opacity-10 d-flex justify-content-center align-items-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-calendar-day text-info fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Declined */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div className="card flex-fill  shadow-sm">
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-1 fw-bold">
                  {" "}
                  ₹{" "}
                  {Number(paymentsCount?.TodaysAmount || 0).toLocaleString(
                    "en-IN",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  )}
                </h4>
                <p className="mb-0 fw-semibold">TodayAmount</p>
              </div>

              <div
                className="rounded-circle bg-warning bg-opacity-10 d-flex justify-content-center align-items-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-hourglass-half text-warning fs-4"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set p-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              {/* <div className="page-btn d-none">
                <Link
                  to="#"
                  className="btn btn-soft-info btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasZipPayments"
                >
                  <i className="ti ti-file fs-4 me-2"></i>
                  <span>Zip Payments</span>
                </Link>
              </div> */}
            </div>
          </div>

          <div className="card-body">
            <div className=" table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={paymentsData} />
              )}
            </div>
          </div>
        </div>

        <CommonFooter />
      </div>

      <style>
        {`
@media (max-width: 576px) {
#offcanvasZipPayments {
width: 90% !important;
}
}

@media (min-width: 577px) and (max-width: 992px) {
#offcanvasZipPayments {
width: 60% !important;
}
}

@media (min-width: 993px) and (max-width: 1440px) {
#offcanvasZipPayments {
width: 30% !important;
}
}

@media (min-width: 1441px)  {
#offcanvasZipPayments {
width: 23% !important;
}
}







`}
      </style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasZipPayments"
        aria-labelledby="offcanvasZipPayments"
      >
        <div className="offcanvas-header pb-0">
          <h4>Zip Payments</h4>

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <hr />

        <div className="offcanvas-body pt-0">
          <form>
            {/* Status */}
            <div className="mb-3">
              <label className="form-label fw-semibold">Payment Made By</label>

              <select className="form-select">
                <option value="">All</option>
                <option value="Unpaid">Bank</option>
                <option value="Paid">Cash</option>
                <option value="Partially Paid">Check</option>
                <option value="Overdue">TDS</option>
                <option value="Cancelled">NEFT</option>
                <option value="Draft">UPI</option>
              </select>
            </div>

            {/* From Date */}
            <div className="mb-3">
              <label className="form-label fw-semibold">From Date</label>

              <input type="date" className="form-control" />
            </div>

            {/* To Date */}
            <div className="mb-4">
              <label className="form-label fw-semibold">To Date</label>

              <input type="date" className="form-control" />
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-end">
              <button type="reset" className="btn btn-light me-2">
                close
              </button>

              <button type="button" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

PaymentsTabs.propTypes = {
  CustomerData: PropTypes.object,
};

export default PaymentsTabs;
